export default function SurveyButttonPressedController(view, model) {
  return ({
    index
  }) => {
    if (model.surveyDone) {
      model.deferred.resolve();
      return;
    }
    switch (index) {
      case 12:
      case 14:
        // left
        view.selectPrevAnswer();
        break;
      case 13:
      case 15:
        // right
        view.selectNextAnswer();
        break;
      case 0:
      case 1:
      case 2:
      case 3:
        view.submit();
        break;
    }
  };
}